import React, { useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fruits } from '../data/fruits';
import FruitCard from '../components/FruitCard';
import './CategoryPage.css';

const CategoryPage = () => {
  const { categoryType } = useParams(); // 'efficacy' or 'season'
  const [selectedFilter, setSelectedFilter] = useState(null);

  const categories = useMemo(() => {
    let allCategories;
    if (categoryType === 'efficacy') {
      allCategories = new Set(fruits.flatMap(f => f.benefits.map(b => b.category)));
    } else if (categoryType === 'season') {
      allCategories = new Set(fruits.map(f => f.season));
    }
    return allCategories ? Array.from(allCategories) : [];
  }, [categoryType]);

  useEffect(() => {
    if (categories.length > 0) {
      setSelectedFilter(categories[0]);
    } else {
      setSelectedFilter(null);
    }
  }, [categories]);

  const filteredFruits = useMemo(() => {
    if (!selectedFilter) return [];

    if (categoryType === 'efficacy') {
      return fruits.filter(fruit =>
        fruit.benefits.some(benefit => benefit.category === selectedFilter)
      );
    }
    if (categoryType === 'season') {
      return fruits.filter(fruit => fruit.season === selectedFilter);
    }
    return [];
  }, [selectedFilter, categoryType]);

  const pageTitle = categoryType === 'efficacy' ? '按功效分类' : '按季节分类';

  return (
    <div className="category-page">
      <h1>{pageTitle}</h1>
      <div className="category-filters">
        {categories.map(category => (
          <button
            key={category}
            className={`filter-button ${selectedFilter === category ? 'active' : ''}`}
            onClick={() => setSelectedFilter(category)}
          >
            {category}
          </button>
        ))}
      </div>
      
      <hr className="divider" />

      {filteredFruits.length > 0 ? (
        <div className="fruit-grid">
          {filteredFruits.map(fruit => (
            <FruitCard key={fruit.id} fruit={fruit} />
          ))}
        </div>
      ) : (
        selectedFilter && <p className="no-results">没有找到符合“{selectedFilter}”条件的水果。</p>
      )}
    </div>
  );
};

export default CategoryPage;
